import React, { useState, useEffect } from "react";
import PageBuilder from "./components/PageBuilder";
import { NoDataFoundTable } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import SplitPane from "react-split-pane";
import { studyLevelFormManagementServices } from "../../../../APIServices/studyLevelFormManagementServices";
import { useParams } from "react-router";
import Swal from "sweetalert2";

const FormBuilder = ({ ids }) => {
  let { studyId } = useParams();
  const [currentPage, setCurrentPage] = useState(null);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [fieldLoading, setFieldLoading] = useState(false);

  const createNewPage = () => {
    const newPage = {
      id: ids?.formId,
      title: ids?.formName,
      content: [],
      settings: {
        pageTitle: ids?.formName,
        pageLayout: "full-width",
        pageBackground: "#ffffff",
        headerStyle: "default",
        footerStyle: "default",
      },
      lastModified: new Date().toISOString(),
    };
    setCurrentPage(newPage);
  };

  const getStudyLevelFormFieldsByVersion = async (e) => {
    setFieldLoading(true);
    let data = await studyLevelFormManagementServices.getStudyLevelFormFieldsByVersion(
      studyId,
      ids?.formId,
      ids?.version
    );
    if (data === "AbortError") {
      setFieldLoading(true);
    } else {
      if (data?.data?.appFormFields) {
        setCurrentPage(data?.data?.appFormFields || {});
      } else {
        createNewPage()
      }
      setFieldLoading(false);
    }
  };

  const addUpdateStudyLevelAppFormFields = async (appFormFields) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Update Form Fields!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true)
        let userData = {};
        userData.studyId = studyId;
        userData.formId = ids?.formId;
        userData.appFormFields = appFormFields
        let data = await studyLevelFormManagementServices.addUpdateStudyLevelAppFormFields(userData);
        if (data?.statusCode === 200) {
          getStudyLevelFormFieldsByVersion();
        }
        setButtonLoader(false)
      }
    });
  };

  const savePage = (appFormFields) => {
    addUpdateStudyLevelAppFormFields(appFormFields)
  };

  useEffect(() => {
    if (ids) {
      getStudyLevelFormFieldsByVersion()
    }
  }, [ids]);

  if (currentPage) {
    return (
      <PageBuilder
        page={currentPage}
        getStudyLevelFormFieldsByVersion={getStudyLevelFormFieldsByVersion}
        onSave={savePage}
      />
    );
  }

  return (
    <>
      <div className="app">
        <SplitPane
          split="horizontal"
          className="position-relative"
          style={{ height: "calc(100vh - 182px)" }}
          minSize={"100%"}
        >
          {!currentPage && (
            <div className="hstack justify-content-center h-100">
              <NoDataFoundTable
                MSG={`Click "Create New Page" to start building your first page with Elementor!`}
              />
            </div>
          )}
        </SplitPane>
      </div>
    </>
  );
}

export default FormBuilder;
